import { mutationOptions } from '@tanstack/react-query';
import { toast } from 'sonner';
import type { AssetUserType } from '@/common/asset';
import { t } from '@/i18n';
import { axios } from '@/lib/utils/axios';
import { getResponse, toastApiError } from '../../common';
import { API_URLS, queryClient } from '../../query.client';

export type AddAssetUserSuccessResponse = AssetUserType;

async function addAssetUser(
	assetId: string,
	assetPayload: Pick<AssetUserType, 'userId'>,
): Promise<AddAssetUserSuccessResponse | null> {
	const response = await axios.post(`${API_URLS.ASSETS.USERS(assetId)}`, assetPayload);
	return getResponse<AddAssetUserSuccessResponse>(response.data);
}
export type AddAssetUserPayload = {
	assetId: string;
	assetPayload: Pick<AssetUserType, 'userId' | 'role'>;
};
export const useMutationAddAssetUser = () => {
	return mutationOptions({
		mutationFn: ({ assetId, assetPayload }: AddAssetUserPayload) => addAssetUser(assetId, assetPayload),
		onSuccess: async (_data, variable) => {
			toast.success(t('assets.users.addSuccess'));
			await queryClient.invalidateQueries({
				queryKey: ['assets', variable.assetId, 'users'],
			});
		},
		onError: (error) => toastApiError(error),
	});
};
